import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { InputTextModule } from "primeng/inputtext";
import { BadgeModule } from "primeng/badge";
import { ButtonModule } from "primeng/button";
import { RadioButtonModule } from "primeng/radiobutton";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { SelectModule } from "primeng/select";
import { RippleModule } from "primeng/ripple";
import { DividerModule } from "primeng/divider";
import { DialogModule } from "primeng/dialog";
import { MenuModule } from "primeng/menu";
import { TooltipModule } from "primeng/tooltip";
import { StyleClassModule } from "primeng/styleclass";
import { AppConfigModule } from "./config/app.config.module";
import { AppLayoutComponent } from "./app.layout.component";
import { AppBreadcrumbComponent } from "./app.breadcrumb.component";
import { AppSidebarComponent } from "./app.sidebar.component";
import { AppTopbarComponent } from "./app.topbar.component";
import { AppRightMenuComponent } from "./app.rightmenu.component";
import { AppMenuComponent } from "./app.menu.component";
import { AppMenuitemComponent } from "./app.menuitem.component";
import { AppSearchComponent } from "./app.search.component";
import { AppFooterComponent } from "./app.footer.component";
import { RetailerSidebarCardComponent } from "../shared/components/retailer-sidebar-card/retailer-sidebar-card.component";
import { ButtonComponent } from "../shared/components/button/button.component";
import { IsMobileDirective } from "../shared/directives/is-mobile.directive";
import { IsNotMobileDirective } from "../shared/directives/is-not-mobile.directive";
import { BottombarComponent } from "./app.bottombar.component";
import { DrawerModule } from "primeng/drawer";

@NgModule({
  declarations: [
    AppLayoutComponent,
    AppBreadcrumbComponent,
    AppSidebarComponent,
    AppTopbarComponent,
    AppRightMenuComponent,
    AppMenuComponent,
    AppMenuitemComponent,
    AppSearchComponent,
    AppFooterComponent,
    BottombarComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    InputTextModule,
    DrawerModule,
    BadgeModule,
    RadioButtonModule,
    ToggleSwitchModule,
    ButtonModule,
    TooltipModule,
    RippleModule,
    MenuModule,
    RouterModule,
    SelectModule,
    DividerModule,
    AppConfigModule,
    DialogModule,
    StyleClassModule,
    RetailerSidebarCardComponent,
    ButtonComponent,
    IsMobileDirective,
    IsNotMobileDirective,
    DrawerModule,
  ],
})
export class AppLayoutModule {}
